import { createFileRoute } from "@tanstack/react-router";
import { NewSalePage } from "@/components/sales/NewSalePage";
import { requireAuth } from "@/lib/require-auth";

export const Route = createFileRoute("/sales_/new")({
  beforeLoad: () => {
    requireAuth();
  },
  component: NewSalePage,
});
